import {
  ContractorType,
  type InstallerProgram,
} from '../../../../../types/api';
import { INSTALLER_PROGRAM_APPROVED_STATUSES } from '../../constants';
import { LOAN } from '../loan/constants';
import type { PROJECT_TYPE } from '../loan/types';

// Helpers about the installer's approved programs (Installer_Program__c).

/**
 * The approved Milestone program that applies to the given project type.
 * Programs are single-type (Flex or Solar): a Flex project matches a Flex
 * program, and any solar project (Solar / Solar+) matches a Solar program.
 * Returns undefined when the installer has no matching approved program —
 * used to gate the Milestone questions and the borrower_advance requirement
 * together so visibility and validation can't drift.
 */
export const findApprovedMilestoneProgramForProjectType = (
  programs: InstallerProgram[] | undefined,
  projectType: PROJECT_TYPE | undefined
): InstallerProgram | undefined => {
  const requiredContractorType =
    projectType === LOAN.PROJECT_TYPE.FLEX
      ? ContractorType.FLEX
      : ContractorType.SOLAR;
  return programs?.find(
    (program) =>
      program.type.includes('Milestone') &&
      INSTALLER_PROGRAM_APPROVED_STATUSES.includes(program.status) &&
      program.contractor_type === requiredContractorType
  );
};

/** Whether the installer has an approved Milestone program for the project type. */
export const hasApprovedProgramForProjectType = (
  programs: InstallerProgram[] | undefined,
  projectType: PROJECT_TYPE | undefined
): boolean =>
  findApprovedMilestoneProgramForProjectType(programs, projectType) !==
  undefined;
